import jsPDF from 'jspdf';
import {
  dateFormat,
  getTextWidth,
  roundAndFormat,
} from '../../../../lib/utils';
import { BOMReportPDMops } from '../../../../types/BillOfMaterial';
import { printPdfViaFrame } from './GeneratePDFPrint';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import { float } from 'html2canvas/dist/types/css/property-descriptors/float';

export async function generatePDMopsPrint({ data }: { data: BOMReportPDMops }) {
  showLoadingScreen();

  const doc = new jsPDF('p', 'px', 'a4');
  const fontType = 'helvetica';
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.text(
    ['Bill of Materials'],
    (pageWidth - getTextWidth(doc, 'Bill of Materials', 14, fontType)) / 2,
    20,
  );
  doc.setFontSize(12);
  doc.line(10, 30, pageWidth - 10, 30);

  doc.setFontSize(10);
  doc.text([`Proder: ${data.header.proderno}`], 45, 40);
  doc.text(
    [`Buyer: ${data.header.buyerCode}`],
    (pageWidth -
      getTextWidth(doc, `Buyer: ${data.header.buyerCode}`, 12, fontType)) /
      2,
    40,
  );
  doc.text(
    [
      `Date Shipment: ${data.header.dateshipment != null ? dayjs(data.header.dateshipment).format(dateFormat) : ''}`,
    ],
    pageWidth -
      getTextWidth(
        doc,
        `Date Shipment: ${data.header.dateshipment != null ? dayjs(data.header.dateshipment).format(dateFormat) : ''}`,
        12,
        fontType,
      ) -
      45,
    40,
  );

  doc.text(
    [
      `Date Prepared : ${data.header.preparedDate != null ? dayjs(data.header.preparedDate).format(dateFormat) : ''}`,
    ],
    45,
    55,
  );
  doc.text(
    [`Prepared By: ${data.header.preparedBy}`],
    (pageWidth -
      getTextWidth(
        doc,
        `Prepared By: ${data.header.preparedBy}`,
        12,
        fontType,
      )) /
      2,
    55,
  );

  doc.line(10, 60, pageWidth - 10, 60);

  // const poHeader = [
  //   'PO No',
  //   'Set No',
  //   'Sku Number',
  //   'Description',
  //   'Glaze Name',
  //   'Qty Order',
  //   'Unit',
  //   'Size',
  //   'Finish Name',
  // ];
  //
  // const tableData = data.poDetails.map((item) => [
  //   item.pono,
  //   item.setPackingNo,
  //   item.skuDescription,
  //   item.skuNumber,
  //   item.glazeName,
  //   item.orderQty,
  //   item.boxUnit,
  //   item.size,
  //   item.finishName,
  // ]);
  //
  // tableData.unshift(poHeader);

  let tableHeight: number | undefined = 70;
  // autoTable(doc, {
  //   startY: 70,
  //   body: tableData,
  //   theme: 'plain',
  //   styles: {
  //     fontSize: 10,
  //     textColor: [0, 0, 0],
  //     cellPadding: 3,
  //   },
  //   columnStyles: {
  //     2: { cellWidth: 'auto' }, // Adjust column width for Description column
  //   },
  //   didDrawPage: (d) => {
  //     tableHeight = d.cursor?.y;
  //   },
  // });

  const tableDataMap = data.poDetails.reduce<{ [key: string]: any[] }>(
    (acc, item) => {
      const pono = item.pono;
      if (!acc[pono]) {
        acc[pono] = [];
      }
      acc[pono].push([
        item.pono,
        item.setPackingNo,
        item.skuDescription,
        item.skuNumber,
        item.glazeName,
        item.orderQty,
        item.boxUnit,
        item.size,
        item.finishName,
      ]);
      return acc;
    },
    {},
  );

  const tableDataArray: any[][] = Object.values(tableDataMap);
  const createTable = (data: any[][]) => {
    const headers = [
      'Set No',
      'Sku Number',
      'Description\nSize',
      'Glaze Name\nFinish Name',
      'Unit',
      'Qty Order',
    ];

    const poTableData = data.map((item) => [
      item[1], // Set No
      item[3], // Sku Number
      `${item[2]}\n${item[7]}`, // Description, Size
      `${item[4]}\n${item[8]}`, // Glaze Name Finish Name
      item[6], // Unit
      item[5], // Qty Order
    ]);

    poTableData.unshift(headers);

    autoTable(doc, {
      startY:
        tableHeight != undefined && tableHeight !== 70 ? tableHeight + 15 : 85,
      body: poTableData,
      theme: 'plain',
      styles: {
        fontSize: 10,
        textColor: [0, 0, 0],
        cellPadding: 3,
      },
      columnStyles: {
        2: { cellWidth: 'auto' }, // Adjust column width for Description column
      },
      didDrawPage: (d) => {
        tableHeight = d.cursor?.y;
      },
    });
  };

  tableDataArray.forEach((group: any[][]) => {
    // Extract pono from the first row of the group
    const pono = group[0][0];
    // Add PO number to the PDF
    doc.text(
      `PO: ${pono}`,
      10,
      (tableHeight != undefined && tableHeight !== 70 ? tableHeight : 70) + 10,
    );
    // Create table for the group
    createTable(group);
  });

  doc.setFontSize(13);
  doc.setFont(fontType, 'bold');
  doc.text(
    'Summary of Needed Materials',
    (pageWidth -
      getTextWidth(doc, 'Summary of Needed Materials', 13, fontType)) /
      2,
    tableHeight + 10,
  );
  doc.setFontSize(12);
  doc.setFont(fontType, 'normal');

  doc.text('A. Greenware', 10, tableHeight + 20);
  const greenwareHeader = ['Clay Type', 'Formed Wet (kilos)', 'Qty'];
  const greenwareTableData = data.materialDetails
    .filter((detail) => detail.groupDescription === 'Greenware')
    .map((item) => [item.materialName, item.qty, item.purchaseQty]);
  greenwareTableData.unshift(greenwareHeader);
  let greenwareTableHeight: number | undefined = 0;
  autoTable(doc, {
    startY: tableHeight + 30,
    body: greenwareTableData,
    theme: 'plain',
    styles: {
      fontSize: 10,
      textColor: [0, 0, 0],
      cellPadding: 3,
    },
    columnStyles: {
      2: { cellWidth: 'auto' }, // Adjust column width for Description column
    },
    didDrawPage: (d) => {
      if (d.cursor !== null && tableHeight != null) {
        greenwareTableHeight = d.cursor?.y + 20;
      }
    },
  });

  doc.text('B. GLazing', 10, greenwareTableHeight);
  const glazingHeader = [
    'Material Name',
    'Supplier',
    'Qty',
    'Unit',
    'Qty Kilo Grams',
  ];
  const glazingTableData = data.materialDetails
    .filter((detail) => detail.groupDescription === 'Glazing')
    .map((item) => [
      item.materialName,
      item.brand,
      roundAndFormat(Number(item.totalQty), 100000, 5),
      item.unit,
      item.purchaseQty,
    ]);
  glazingTableData.unshift(glazingHeader);
  let glazingTableHeight: number | undefined = 0;
  autoTable(doc, {
    startY: greenwareTableHeight + 10,
    body: glazingTableData,
    theme: 'plain',
    styles: {
      fontSize: 10,
      textColor: [0, 0, 0],
      cellPadding: 3,
    },
    columnStyles: {
      2: { cellWidth: 'auto' }, // Adjust column width for Description column
    },
    didDrawPage: (d) => {
      if (d.cursor !== null && tableHeight != null) {
        glazingTableHeight = d.cursor?.y + 20;
      }
    },
  });

  doc.text('C. Finish / Attachment', 10, glazingTableHeight);
  const finishHeader = [
    'Paint Material Name',
    'Brand',
    'Qty',
    'Unit',
    'Qty Litters',
  ];
  const finishTableData = data.materialDetails
    .filter((detail) => detail.groupDescription === 'Finish / Attachment')
    .map((item) => [
      item.materialName,
      item.brand,
      roundAndFormat(Number(item.totalQty), 100000, 5),
      item.unit,
      item.purchaseQty,
    ]);
  finishTableData.unshift(finishHeader);
  let finishTableHeight: number | undefined = 0;
  autoTable(doc, {
    startY: glazingTableHeight + 10,
    body: finishTableData,
    theme: 'plain',
    styles: {
      fontSize: 10,
      textColor: [0, 0, 0],
      cellPadding: 3,
    },
    columnStyles: {
      2: { cellWidth: 'auto' }, // Adjust column width for Description column
    },
    didDrawPage: (d) => {
      if (d.cursor !== null && tableHeight != null) {
        finishTableHeight = d.cursor?.y + 20;
      }
    },
  });

  doc.text('D. Attachment', 10, finishTableHeight);
  const attachmentHeader = [
    'Paint Material Name',
    'Brand',
    'Qty',
    'Unit',
    'Qty Litters',
  ];
  const attachmentTableData = data.materialDetails
    .filter((detail) => detail.groupDescription === 'Attachment')
    .map((item) => [
      item.materialName,
      item.brand,
      roundAndFormat(Number(item.totalQty), 100000, 5),
      item.unit,
      item.purchaseQty,
    ]);
  attachmentTableData.unshift(attachmentHeader);
  let attachmentTableHeight: number | undefined = 0;
  autoTable(doc, {
    startY: finishTableHeight + 10,
    body: attachmentTableData,
    theme: 'plain',
    styles: {
      fontSize: 10,
      textColor: [0, 0, 0],
      cellPadding: 3,
    },
    columnStyles: {
      2: { cellWidth: 'auto' }, // Adjust column width for Description column
    },
    didDrawPage: (d) => {
      if (d.cursor !== null && tableHeight != null) {
        attachmentTableHeight = d.cursor?.y + 20;
      }
    },
  });

  doc.text('E. Packing Materials', 10, attachmentTableHeight);
  const packingMaterialHeader = [
    'Paint Material Name',
    'Description',
    'Brand',
    'Qty',
    'Unit',
    'Qty Litters',
  ];
  const packingMaterialTableData = data.materialDetails
    .filter((detail) => detail.groupDescription === 'Packing Materials')
    .map((item) => [
      item.materialCode,
      item.materialName,
      item.brand,
      roundAndFormat(Number(item.totalQty), 100000, 5),
      item.unit,
      item.purchaseQty,
    ]);
  packingMaterialTableData.unshift(packingMaterialHeader);
  let packingMaterialTableHeight: number | undefined = 0;
  autoTable(doc, {
    startY: attachmentTableHeight + 10,
    body: packingMaterialTableData,
    theme: 'plain',
    styles: {
      fontSize: 10,
      textColor: [0, 0, 0],
      cellPadding: 3,
    },
    columnStyles: {
      2: { cellWidth: 'auto' }, // Adjust column width for Description column
    },
    didDrawPage: (d) => {
      if (d.cursor !== null && tableHeight != null) {
        packingMaterialTableHeight = d.cursor?.y + 20;
      }
    },
  });

  doc.text('F. Master Box', 10, packingMaterialTableHeight);
  const masterBoxHeader = [
    'Set No',
    'SKU Number',
    'Box Type',
    'Size',
    'Qty',
    'Unit',
  ];
  const masterBoxTableData = data.materialDetails
    .filter((detail) => detail.groupDescription === 'Masterbox')
    .map((item) => [
      item.materialCode,
      item.materialName,
      item.brand,
      roundAndFormat(Number(item.totalQty), 100000, 5),
      item.unit,
      item.purchaseQty,
    ]);
  masterBoxTableData.unshift(masterBoxHeader);
  let masterBoxTableHeight: number | undefined = 0;
  autoTable(doc, {
    startY: packingMaterialTableHeight + 10,
    body: masterBoxTableData,
    theme: 'plain',
    styles: {
      fontSize: 10,
      textColor: [0, 0, 0],
      cellPadding: 3,
    },
    columnStyles: {
      2: { cellWidth: 'auto' }, // Adjust column width for Description column
    },
    didDrawPage: (d) => {
      if (d.cursor !== null && tableHeight != null) {
        masterBoxTableHeight = d.cursor?.y + 20;
      }
    },
  });

  doc.text('G. Inner Box', 10, masterBoxTableHeight);
  const innerBoxHeader = [
    'Paint Material Name',
    'Description',
    'Brand',
    'Qty',
    'Unit',
    'Qty Litters',
  ];
  const innerBoxTableData = data.materialDetails
    .filter((detail) => detail.groupDescription === 'Inner Box')
    .map((item) => [
      item.materialCode,
      item.materialName,
      item.brand,
      roundAndFormat(Number(item.totalQty), 100000, 5),
      item.unit,
      item.purchaseQty,
    ]);
  innerBoxTableData.unshift(innerBoxHeader);
  let innerBoxTableHeight: number | undefined = 0;
  autoTable(doc, {
    startY: masterBoxTableHeight + 10,
    body: innerBoxTableData,
    theme: 'plain',
    styles: {
      fontSize: 10,
      textColor: [0, 0, 0],
      cellPadding: 3,
    },
    columnStyles: {
      2: { cellWidth: 'auto' }, // Adjust column width for Description column
    },
    didDrawPage: (d) => {
      if (d.cursor !== null && tableHeight != null) {
        innerBoxTableHeight = d.cursor?.y + 20;
      }
    },
  });

  doc.text('H. Labelling Materials / Other Materials', 10, innerBoxTableHeight);
  const otherHeader = [
    'Paint Material Name',
    'Description',
    'Brand',
    'Qty',
    'Unit',
    'Qty Litters',
  ];
  const otherTableData = data.materialDetails
    .filter(
      (detail) =>
        detail.groupDescription === 'Labelling Materials / Other Materials',
    )
    .map((item) => [
      item.materialCode,
      item.materialName,
      item.brand,
      roundAndFormat(Number(item.totalQty), 100000, 5),
      item.unit,
      item.purchaseQty,
    ]);
  otherTableData.unshift(otherHeader);
  autoTable(doc, {
    startY: innerBoxTableHeight + 10,
    body: otherTableData,
    theme: 'plain',
    styles: {
      fontSize: 10,
      textColor: [0, 0, 0],
      cellPadding: 3,
    },
    columnStyles: {
      2: { cellWidth: 'auto' }, // Adjust column width for Description column
    },
  });

  // doc.save(`pdmops-bill-of-material-${code}`);
  printPdfViaFrame(doc);

  hideLoadingScreen();
}

function showLoadingScreen() {
  // Display loading screen UI (e.g., overlay with spinner)
  const loadingScreen = document.getElementById('loading-screen');
  if (loadingScreen) {
    loadingScreen.style.display = 'block';
  }
}

function hideLoadingScreen() {
  // Hide loading screen UI
  const loadingScreen = document.getElementById('loading-screen');
  if (loadingScreen) {
    loadingScreen.style.display = 'none';
  }
}
